import { type Color } from '@mui/material'

export const dhlRed = {
  100: '#0F253F',
  200: '#16375C',
  300: '#1E4A7A',
  400: '#245A94',
  500: '#2F6FB8',
  600: '#4E8FDB',
  700: '#7FB0EA',
  800: '#A9C9F5',
  900: '#CFE3FF',
} satisfies Partial<Color>
